import React from 'react';
import ReportingCompareEventsPage from '../components/ReportingCompareEventsPage';

const axios = require('axios').default;

const ReportingCompareEventsApp = (props) => {
  if (props.csrfToken) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = props.csrfToken;
  }
  return <ReportingCompareEventsPage {...props} />;
};

export default ReportingCompareEventsApp;
